import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {ChecklistType, OrderReviewChecklist} from "../../../store/state/order-review-checklist.state";
import {environment} from "../../../../environments/environment";
import {GMTToLocalDateTime} from "../../date-functions";

@Component({
    selector: 'review-checklist-documents',
    templateUrl: './review-checklist-documents.template.html',
    styleUrls: ['./review-checklist-documents.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ReviewChecklistDocumentsComponent {

	readonly APPLICATION_REVIEW_CHECKLIST_TYPE: ChecklistType = ChecklistType.APPLICATION_REVIEW;

	@Input() applicationReviewerChecklist: OrderReviewChecklist;

	get applicationReviewerChecklistCreationDate(): Date {
		return GMTToLocalDateTime(this.applicationReviewerChecklist.declineDate != null ? this.applicationReviewerChecklist.declineDate : this.applicationReviewerChecklist.acceptanceDate);
	}

	openChecklistDocument(checklist: OrderReviewChecklist, checklistType: ChecklistType) {
		window.open(`${environment.applicationUrl}/review-checklist-document/${checklist.orderCorrelationId}/${checklistType}`, '_blank');
	}

}
